<template>
  <div class="contents userMgt">
    <div class="title flexB">
      <h2>이벤트 관리</h2>
    </div>
    <div class="box one filter">
      <div class="flex">
        <p class="bold">검색조건</p>
        <select v-model="inputMode">
          <option value="" selected disabled>선택</option>
          <option value="title">제목</option>
        </select>
        <input type="text" v-model="searchWord" @keyup.enter="search" />
      </div>
      <div class="flex">
        <p class="bold">카테고리</p>
        <label>
          <input type="radio" value="" checked v-model="category" />전체
        </label>
        <label>
          <input type="radio" value="PLACE" v-model="category" />
          웨딩장소
        </label>
        <label>
          <input type="radio" value="WEDDING" v-model="category" />
          웨딩패키지
        </label>
        <label>
          <input type="radio" value="PHOTO" v-model="category" />
          사진
        </label>
        <label>
          <input type="radio" value="DRESS" v-model="category" />
          드레스
        </label>
        <label>
          <input type="radio" value="BEAUTY" v-model="category" />
          헤어/메이크업
        </label>
        <label>
          <input type="radio" value="HONEYMOON" v-model="category" />
          허니문
        </label>
        <label>
          <input type="radio" value="ETC" v-model="category" />
          기타
        </label>
      </div>
      <div class="buttonWrap">
        <button class="basic" @click="search">검색</button>
        <button class="line" @click="reset">초기화</button>
      </div>
    </div>

    <div class="box one">
      <h2 class="bold">
        이벤트 리스트
        <button class="right basic">
          <router-link to="/admin/eventmanage/register"
            >이벤트 등록</router-link
          >
        </button>
      </h2>
      <table>
        <colgroup>
          <col style="width: 15%" />
          <col style="width: 20%" />
          <col style="width: 45%" />
          <col style="width: 20%" />
        </colgroup>
        <tr>
          <th>번호</th>
          <th>카테고리</th>
          <th>제목</th>
          <th>등록일</th>
        </tr>
        <tr v-for="(data, i) in list" :key="i">
          <td>{{ total + 1 - (i + 1 + (currentPage - 1) * 10) }}</td>
          <td>
            {{
              data.category == "PLACE"
                ? "웨딩장소"
                : data.category == "WEDDING"
                ? "웨딩패키지"
                : data.category == "PHOTO"
                ? "사진"
                : data.category == "DRESS"
                ? "드레스"
                : data.category == "BEAUTY"
                ? "헤어/메이크업"
                : data.category == "HONEYMOON"
                ? "허니문"
                : data.category == "ETC"
                ? "기타"
                : ""
            }}
          </td>
          <td>
            <router-link to @click.native="handleMove(data._id)">{{
              data.title
            }}</router-link>
          </td>
          <td>{{ moment(data.createdAt).format("YYYY.MM.DD HH:mm") }}</td>
        </tr>
      </table>
      <NoData v-if="isNodata" />
      <div class="pagination" v-if="list.length > 0">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { fetchEventList } from "@/api/admin";
import NoData from "@/components/contents/Nodata";
import { format } from "@/mixins/format";
export default {
  mixins: [format],
  components: { NoData },
  data() {
    return {
      moment: moment,
      category: "",
      list: [],
      inputMode: "",
      searchWord: "",
      total: 0,
      currentPage: 1,
      isNodata: false,
    };
  },
  computed: {
    ...mapState(["navbarState"]),
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", "10");
  },
  mounted() {
    this.getEventList();
  },
  methods: {
    reset() {
      this.inputMode = "";
      this.searchWord = "";
      this.category = "";
      this.currentPage = 1;
      this.list = [];
      this.total = 0;
      this.getEventList();
    },
    search() {
      if (this.searchWord && this.inputMode == "") {
        this.$alert("검색 조건을 선택해 주세요.", {
          confirmButtonText: "확인",
          center: true,
        });
        return;
      }
      this.getEventList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getEventList();
    },
    handleMove(id) {
      this.$router.push({ name: "eventregister", query: { id: id } });
    },
    getEventList() {
      let params = {
        page: this.currentPage,
        searchWord: this.searchWord,
        inputMode: this.inputMode,
        category: this.category,
      };
      fetchEventList(params).then((res) => {
        if (res.data.status == 200) {
          this.list = res.data.data;
          this.total = res.data.total;
          this.isNodata = this.total == 0 ? true : false;
        } else {
          this.$alert(res.data.message, {
            confirmButtonText: "확인",
            center: true,
          });
        }
      });
    },
  },
};
</script>
